import { useState } from 'react';
import { Spin, Form, message } from 'antd';
import { NavLink, useNavigate } from 'react-router-dom';
import { splash } from '../../assets/images/images';
import { logo } from '../../assets/images/images';
import { ThemeButton, ThemeInput } from '../../components/components';
import { useSetLoginMutation } from '../../services/auth';
import { addKeyToStorage } from '../../helpers/helpers';

const LoginMob = ({
  onClick,
  email,
  setEmail,
  password,
  setPassword,
  isLoading,
}) => {
  return (
    <div className="md:hidden flex flex-col justify-center items-center bg-white min-h-screen px-10">
      <img src={splash} alt="" className="-mt-6" width={180} />
      <Form name="normal_login" className="login-form w-full mt-5">
        <Form.Item
          name="phoneNumber"
          rules={[
            {
              type: 'email',
              message: 'Please enter a valid email address',
            },
            {
              required: true,
              message: 'Please enter your email',
            },
          ]}
        >
          <ThemeInput
            label={'Email'}
            placeholder={'Email'}
            labelPrimary
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[
            {
              required: true,
              message: 'Please enter your password',
            },
          ]}
        >
          <ThemeInput
            label={'Password'}
            placeholder={'Password'}
            labelPrimary
            password
            onChange={e => setPassword(e.target.value)}
            value={password}
          />
        </Form.Item>

        <Form.Item className="flex justify-center">
          <ThemeButton
            type="primary"
            htmlType="submit"
            onClick={onClick}
            content={
              <>
                {isLoading ? (
                  <Spin className="mt-1" />
                ) : (
                  <div className="flex items-center">
                    {/* <img src={login_icon} alt="" width={21} height={21} /> */}
                    <p className="ml-2 text-lg text-themeBlack">Log in</p>
                  </div>
                )}
              </>
            }
          />
        </Form.Item>
      </Form>
    </div>
  );
};

const Login = ({ setAuthUser }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [setLogin, { isLoading }] = useSetLoginMutation();

  const handleLogin = async () => {
    if (email && password) {
      const response = await setLogin({
        email: email,
        password: password,
      });
      if (!response?.data?.error) {
        if (!response?.data?.data?.user?.isSuperAdmin) {
          message.error('Access denied. Administrators only.');
          return;
        }
        message.success(response?.data?.msg);
        addKeyToStorage('token', response.data?.data?.token);
        setAuthUser(response?.data?.data?.user?._id);
        navigate('/dashboard');
      } else {
        message.error(response?.data?.msg || '');
      }
    }
  };

  return (
    <>
      <div className="h-screen md:flex hidden">
        <div className="w-2/4 h-full flex justify-end items-center bg-white">
          <div
            className="bg-[#FEF2E6] rounded-bl-xl rounded-tl-xl shadow-[-10px_5px_30px_-10px_rgba(0,0,0,.2)] flex justify-center items-center"
            style={{ height: '87vh', width: '85%' }}
          >
            <div className="flex flex-col items-center">
              <p className="text-lg text-[#58433B] mb-1">Welcome to</p>
              <h1 className=" text-4xl text-[#58433B] font-medium mb-3">
                My Guilty Dogs
              </h1>
              <p className="text-[#A8ACB1] text-sm text-center w-8/12 mb-6">
                Admin Panel
              </p>
              <img src={splash} width={350} alt="" />
            </div>
          </div>
        </div>
        <div className="bg-white w-2/4 h-full flex justify-start items-center">
          <div
            className="rounded-br-xl rounded-tr-xl shadow-[30px_5px_30px_-15px_rgba(0,0,0,.2)] flex flex-col justify-center items-center px-10"
            style={{ height: '87vh', width: '85%' }}
          >
            <Form name="normal_login" className="login-form w-full mt-5">
              <Form.Item
                name="email"
                rules={[
                  {
                    type: 'email',
                    message: 'Invalid email address',
                  },
                  {
                    required: true,
                    message: 'Please enter your email',
                  },
                ]}
              >
                <ThemeInput
                  label={'Email'}
                  placeholder={'Email'}
                  labelPrimary
                  value={email}
                  onChange={e => setEmail(e.target.value.toLowerCase().trim())}
                />
              </Form.Item>
              <Form.Item
                name="password"
                rules={[
                  {
                    required: true,
                    message: 'Please enter your password',
                  },
                ]}
              >
                <ThemeInput
                  label={'Password'}
                  placeholder={'Password'}
                  labelPrimary
                  password
                  value={password}
                  onChange={e => setPassword(e.target.value.trim())}
                />
              </Form.Item>

              <Form.Item className="flex justify-center mt-8">
                <ThemeButton
                  type="primary"
                  htmlType="submit"
                  onClick={handleLogin}
                  className={'!h-10 w-40 flex'}
                  content={
                    <>
                      {isLoading ? (
                        <Spin className="mt-1" />
                      ) : (
                        <div className="flex items-center">
                          <p className="ml-2 text-lg text-themeBlack">Log In</p>
                        </div>
                      )}
                    </>
                  }
                />
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
      <LoginMob
        onClick={handleLogin}
        email={email}
        setEmail={e => setEmail(e)}
        password={password}
        setPassword={e => setPassword(e)}
        isLoading={isLoading}
      />
    </>
  );
};

export default Login;
